module.exports = __webpack_public_path__ + "static/img/btn_heying_nor.b6921e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_heying_nor.png
// module id = 4C5W
// module chunks = 1